import { api, headers } from "@/config/axiosInstance";
import {
  ClientGuestDataDto,
  ConfirmGuestPresenceDto,
  EventClientCreateDto,
  EventClientDataDto,
  EventClientIndexPaginatedDto,
  EventClientIndexQueryDto,
  UpdateClientGuestDto,
} from "@/pages/events/types";

export const useEventClient = () => {
  const getEventClients = ({
    page,
    perPage,
    name,
    email,
    cpf,
    guestName,
    eventId,
    isPresent,
    validatedBy,
    validationMethod,
    checkin,
  }: EventClientIndexQueryDto) => {
    let params = `page=${page}&perPage=${perPage}`;

    if (eventId) {
      params = `${params}&eventId=${eventId}`;
    }

    if (name) {
      params = `${params}&name=${name}`;
    }
    if (email) {
      params = `${params}&email=${email}`;
    }

    if (guestName) {
      params = `${params}&guestName=${guestName}`;
    }

    if (cpf) {
      params = `${params}&cpf=${cpf}`;
    }

    if (isPresent !== undefined) {
      params = `${params}&isPresent=${isPresent}`;
    }

    if (validatedBy) {
      params = `${params}&validatedBy=${validatedBy}`;
    }

    if (validationMethod) {
      params = `${params}&validationMethod=${validationMethod}`;
    }

    if (checkin) {
      params = `${params}&checkin=${checkin}`;
    }

    return api.get<EventClientIndexPaginatedDto>(
      `/event-client/index?${params}`
    );
  };

  const eventClientCreate = (data: EventClientCreateDto) => {
    return api.post<EventClientDataDto>(`/event-client/create`, data);
  };

  const eventClientUpdate = (id: number, data: EventClientCreateDto) => {
    return api.put<EventClientDataDto>(`/event-client/${id}`, data);
  };

  const eventClientDelete = (id: number) => {
    return api.delete<void>(`/event-client/${id}`);
  };

  const getClientByEventId = (eventId: number) => {
    return api.get<EventClientDataDto[]>(`/event-client/by-event/${eventId}`);
  };

  const getGuestByClient = (id: number) => {
    return api.get<ClientGuestDataDto[]>(`/event-client/${id}/client-guest`);
  };

  const confirmGuestPresenceManual = (
    id: number,
    data: ConfirmGuestPresenceDto
  ) => {
    return api.patch(`/event-client/${id}/confirm-presence-manual`, data);
  };

  const eventClientImport = (eventId: number, file: any) => {
    const formData = new FormData();
    formData.append("file", file);

    return api.post(`event-client/${eventId}/file`, formData, {
      headers: { ...headers, "Content-Type": "multipart/form-data" },
    });
  };

  const updateClientGuest = (id: number, body: UpdateClientGuestDto) => {
    return api.put(`/event-client/clientGuest/${id}`, {
      ...body,
      entranceId: Number(body.entranceId),
    });
  };

  const sendInviteMail = (id: number) => {
    return api.post(`event-client/send-mail/${id}`);
  };

  const donwloadInvite = (id: number) => {
    return api.get(`/event-client/download-invite/${id}`, {
      responseType: "blob",
    });
  };

  const deleteGuest = (id: number) => {
    return api.delete(`/event-client/client-guest/${id}`);
  };

  const addClientGuest = (
    eventClientId: number,
    body: UpdateClientGuestDto
  ) => {
    return api.post(`/event-client/${eventClientId}/client-guest`, {
      ...body,
      eventClientId: Number(eventClientId),
      entranceId: Number(body.entranceId),
    });
  };

  const downloadList = (id: number) => {
    return api.get(`/event-client/exportar/${id}`, {
      responseType: "blob",
    });
  };

  return {
    getEventClients,
    eventClientCreate,
    eventClientUpdate,
    eventClientDelete,
    getClientByEventId,
    getGuestByClient,
    confirmGuestPresenceManual,
    eventClientImport,
    updateClientGuest,
    addClientGuest,
    sendInviteMail,
    donwloadInvite,
    deleteGuest,
    downloadList,
  };
};
